import { createContext } from "react";
import { InfoAssinatura } from "../../types/Assinatura";

export type AssinaturaContextType = {
  info: InfoAssinatura | null;
  fluxoNovo: boolean | null;
  loading: boolean;
  refresh: () => Promise<void>;
};

export const AssinaturaContext = createContext<AssinaturaContextType>(null!);
